import { LocationResponsibleState } from './types';

export const state = (): LocationResponsibleState => initialState();

export const initialState = (): LocationResponsibleState => ({
  locationResponsibles: {
    items: [],
    isLoading: false,
    total: 0,
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: [],
    },
  },
});
